module.exports = __webpack_public_path__ + "img/ru.0f83bd3f.svg";